import ReactDOM from "react-dom/client";
// React must be imported to render jsx. Vue side doesn't have linter config to figure out what's up
import React from "react";

const roots: { ref: any; root: ReactDOM.Root }[] = [];

function renderReactComponent(ref: any, Component: any, props?: any) {
  let root = roots.find((r) => r.ref === ref)?.root;
  if (!root) {
    root = ReactDOM.createRoot(ref);
    roots.push({ ref, root });
  }

  root.render(<Component {...props} />);
}

export default renderReactComponent;
